import React from "react";
import {Button, Form, FormGroup, FormControl, ControlLabel, Modal} from "react-bootstrap";
import {validateEmail} from "tools";
import Request from "request";
import CreateList from "./CreateList";

class TicketCreateText extends React.Component {
	state = {
		emails: []
	};

	handleParseEmails() {
		var emails = this.emailsInputRef.value
			.split(/[\s,;]+/)
//			.filter(value => validateEmail(value))
			.filter((value, index, self) => self.indexOf(value) === index)
		;
		this.setState({emails});
	}
	handleChangeEmail(oldEmail, newEmail) {
		var {emails} = this.state;
		const index = this.state.emails.findIndex(email => email === oldEmail);

		if(index >= 0) {
			emails[index] = newEmail;
			this.setState({emails});
		}
	}
	handleDeleteEmail(email) {
		var emails = this.state.emails.slice();
		const index = emails.findIndex(item => item === email);
		if(index >= 0) {
			emails.splice(index, 1);
			this.setState({emails});
		}
	}
	handleCreate() {
		const {event, onCreate} = this.props;
		const {emails} = this.state;

		Request.post(`/api/cp/event/${event.eventPassword}/ticket`, {email: emails})
			.then(onCreate);
	}

	UNSAFE_componentWillReceiveProps() {
		this.setState({emails: []});
	}

	render() {
		const {onHide, show} = this.props;
		var {emails} = this.state;

		const invalidEmails = emails.filter(email => !validateEmail(email));

		return (
			<Modal show={show} onHide={onHide} bsSize="large">
				<Modal.Header closeButton>
					<Modal.Title>Добавление билетов с рассылкой</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{emails.length ?
						<CreateList emails={emails} onChange={this.handleChangeEmail.bind(this)} onDelete={this.handleDeleteEmail.bind(this)} />
						:
						<Form>
							<FormGroup>
								<ControlLabel>Укажите список eMail адресов для рассылки</ControlLabel>
								<FormControl componentClass="textarea" inputRef={ref => this.emailsInputRef = ref} rows={6}/>
							</FormGroup>
						</Form>
					}
				</Modal.Body>
				<Modal.Footer>
					{invalidEmails.length > 0 && <span style={{color: 'red'}}>Необходимо удалить или исправить некорректные адреса </span>}
					{emails.length ?
						<Button bsStyle="primary" onClick={this.handleCreate.bind(this)} disabled={emails.filter(e => !validateEmail(e)).length > 0}>Создать и разослать билеты</Button>
						:
						<Button bsStyle="primary" onClick={this.handleParseEmails.bind(this)}>Далее</Button>
					}
					<Button onClick={onHide}>Закрыть</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

export default TicketCreateText;
